/* ============================================================
   IUTIENDA — Site Life v2 (animaciones en todo el sitio)
   Archivo aditivo: no reemplaza theme.js, solo observa el DOM
   y agrega clases/efectos visuales. No toca lógica de carrito,
   filtros ni AJAX que ya tienes.
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (window.__iutiendaSiteLifeInit) return;
    window.__iutiendaSiteLifeInit = true;

    /* ---------- 1) Scroll reveal ---------- */
    var revealSelectors = [
      '.product-card',
      '.category-card',
      '.testimonial-card',
      '.icon-feature',
      '.brand-logo-item',
      '.footer-feature',
      '.footer-col',
      '.section-header',
      '.text-banner__inner',
      '.iwt__inner',
      '.promo-banner__content'
    ];
    var revealEls = document.querySelectorAll(revealSelectors.join(','));

    if ('IntersectionObserver' in window && revealEls.length) {
      revealEls.forEach(function (el, i) {
        el.classList.add('sl-reveal');
        el.style.setProperty('--sl-i', i % 8);
      });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sl-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('sl-reveal', 'sl-in'); });
    }

    /* ---------- 2) Ripple en botones ---------- */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest(
        '.btn, .add-to-cart-btn, .buy-now-btn, .search-btn, .header-action, .qty-btn, .category-card__cta'
      );
      if (!btn) return;

      var rect = btn.getBoundingClientRect();
      var size = Math.max(rect.width, rect.height);
      var ripple = document.createElement('span');

      ripple.className = 'sl-ripple';
      ripple.style.width = ripple.style.height = size + 'px';
      ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
      ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';

      if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';

      btn.appendChild(ripple);
      setTimeout(function () { ripple.remove(); }, 650);
    });

    /* ---------- 3) Feedback al agregar al carrito ---------- */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.add-to-cart-btn');
      if (!btn || !btn.closest('form')) return;

      var original = btn.innerHTML;
      setTimeout(function () {
        btn.classList.add('sl-added');
        btn.innerHTML = '<i class="fas fa-check"></i> ¡Agregado!';
        setTimeout(function () {
          btn.classList.remove('sl-added');
          btn.innerHTML = original;
        }, 1600);
      }, 350);
    });

    /* ---------- 4) Bounce del badge del carrito ---------- */
    var cartBadge = document.getElementById('cart-badge');
    if (cartBadge && 'MutationObserver' in window) {
      var lastValue = cartBadge.textContent;
      var mo = new MutationObserver(function () {
        if (cartBadge.textContent !== lastValue) {
          lastValue = cartBadge.textContent;
          cartBadge.classList.remove('sl-bounce');
          void cartBadge.offsetWidth;
          cartBadge.classList.add('sl-bounce');
        }
      });
      mo.observe(cartBadge, { childList: true, characterData: true, subtree: true });
    }

    /* ---------- 5) Header con sombra al hacer scroll ---------- */
    var header = document.querySelector('.site-header');
    if (header) {
      var lastScrolled = false;
      window.addEventListener('scroll', function () {
        var scrolled = window.scrollY > 12;
        if (scrolled !== lastScrolled) {
          header.classList.toggle('sl-scrolled', scrolled);
          lastScrolled = scrolled;
        }
      }, { passive: true });
    }

    /* ---------- 6) Hero: entrada de texto en cascada ---------- */
    var heroTitles = document.querySelectorAll('.hero-banner h1, .hero-slide__title');
    heroTitles.forEach(function (heroTitle) {
      if (heroTitle.dataset.slDone) return;
      heroTitle.dataset.slDone = '1';
      var words = heroTitle.textContent.trim().split(/\s+/);
      heroTitle.innerHTML = words.map(function (w, i) {
        return '<span class="sl-hero-line" style="animation-delay:' + (i * 70) + 'ms">' + w + '</span>';
      }).join(' ');
    });

    /* ---------- 7) Back to top: aparece con "pop" ---------- */
    var btt = document.getElementById('back-to-top');
    if (btt) {
      var bttShown = false;
      window.addEventListener('scroll', function () {
        var shouldShow = window.scrollY > 400;
        if (shouldShow && !bttShown) {
          bttShown = true;
          btt.classList.add('sl-pop');
          setTimeout(function () { btt.classList.remove('sl-pop'); }, 400);
        } else if (!shouldShow) {
          bttShown = false;
        }
      }, { passive: true });
    }
    /* ---------- 8) Pulso al cambiar cantidad ---------- */
    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.qty-btn');
      if (!qtyBtn) return;
      var input = qtyBtn.parentElement && qtyBtn.parentElement.querySelector('input');
      if (!input) return;
      input.classList.remove('sl-pulse');
      void input.offsetWidth;
      input.classList.add('sl-pulse');
    });
    /* ---------- 9) Urgencia de stock bajo (dato real) ---------- */
    var stockInput = document.getElementById('variant-debug');
    if (stockInput) {
      var available = stockInput.getAttribute('data-available') === 'true';
      var policy = stockInput.getAttribute('data-policy');
      var inventoryRaw = stockInput.getAttribute('data-inventory');
      var inventory = parseInt(inventoryRaw, 10);

      if (available && policy !== 'continue' && !isNaN(inventory) && inventory > 0 && inventory <= 10) {
        var badge = document.createElement('div');
        badge.className = 'sl-stock-badge';
        badge.innerHTML =
          '<span class="sl-stock-badge__dot"></span>' +
          '¡Solo quedan ' + inventory + (inventory === 1 ? ' unidad!' : ' unidades!');
        var trust = document.querySelector('.product-trust');
        if (trust && trust.parentNode) {
          trust.parentNode.insertBefore(badge, trust.nextSibling);
        }
      }
    }
  });
})();
